import { ClipboardCheck, Tags, type LucideIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/ui/card'
import { StaticLegislationComingSoonBadge } from '../static-legislation-briefing/StaticLegislationComingSoonBadge'
import {
  LVD_REGULATION_CAPABILITIES,
  type RegulationCapabilityConfig,
  type RegulationCapabilityKey,
} from '../../utils/regulationCapabilities'

const LVD_CAPABILITIES_ID_PREFIX = 'lvd-capabilities'

const LVD_CAPABILITY_ICONS: Record<RegulationCapabilityKey, LucideIcon> = {
  validateDesignAndConstruction: ClipboardCheck,
  validateMarkingsAndInstructions: Tags,
}

function V2LvdCapabilityCard({
  capability,
}: {
  capability: RegulationCapabilityConfig
}) {
  const { t } = useTranslation('common')
  const title = t(
    `v2.pages.products.detail.lvdCapabilities.items.${capability.key}.title`
  )
  const showComingSoonBadge = capability.availability === 'comingSoon'
  const Icon = LVD_CAPABILITY_ICONS[capability.key]

  return (
    <Card
      id={`${LVD_CAPABILITIES_ID_PREFIX}-${capability.key}`}
      className='scroll-mt-4 bg-card shadow-none'
    >
      <CardContent className='flex h-full flex-col gap-3 p-3'>
        <div className='flex items-start justify-between gap-2'>
          <Icon
            className='size-6 shrink-0 text-muted-foreground'
            aria-hidden
          />
          {showComingSoonBadge && <StaticLegislationComingSoonBadge />}
        </div>
        <h3 className='text-base font-medium leading-snug text-foreground'>
          {title}
        </h3>
      </CardContent>
    </Card>
  )
}

export function V2LvdCapabilitiesList() {
  const { t } = useTranslation('common')

  return (
    <section className='space-y-3'>
      <h2 className='text-lg font-semibold'>
        {t('v2.pages.products.detail.lvdCapabilities.title')}
      </h2>
      <div className='grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4'>
        {LVD_REGULATION_CAPABILITIES.map((capability) => (
          <V2LvdCapabilityCard key={capability.key} capability={capability} />
        ))}
      </div>
    </section>
  )
}
